/* ─── shared palette + style factory (same look as StateMaster) ─── */
export const PURPLE = "#7c3aed";
export const INDIGO = "#4f46e5";
export const TEAL = "#0d9488";
export const AMBER = "#d97706";
export const ROSE = "#e11d48";
export const EMERALD = "#059669";
export const SKY = "#0284c7";

export const ROW_COLORS = [PURPLE, SKY, TEAL, EMERALD, AMBER, ROSE, INDIGO];

export const getStyles = (from = TEAL, to = INDIGO) => ({
  page: {
    background: "linear-gradient(135deg,#f5f3ff 0%,#eff6ff 40%,#ecfdf5 100%)",
    height: "calc(100vh - 105px)",
    padding: "20px 24px",
    overflowY: "auto",
  },
  headerBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 16,
  },
  headerLeft: { display: "flex", alignItems: "center", gap: 14 },
  headerIcon: {
    width: 52,
    height: 52,
    borderRadius: 14,
    background: `linear-gradient(135deg,${from} 0%,${to} 100%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 26,
    color: "#fff",
    boxShadow: `0 6px 18px ${from}55`,
  },
  headerTitle: {
    margin: 0,
    fontSize: 22,
    fontWeight: 800,
    background: `linear-gradient(90deg,${from},${to})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    letterSpacing: 0.3,
  },
  headerSub: { margin: 0, fontSize: 13, color: "#64748b", marginTop: 2 },
  statsRow: { display: "flex", gap: 12, flexWrap: "wrap" },
  stat: (color) => ({
    background: "#fff",
    borderRadius: 12,
    padding: "10px 18px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
    borderTop: `3px solid ${color}`,
    minWidth: 80,
  }),
  statNum: (color) => ({
    fontSize: 22,
    fontWeight: 800,
    color,
    lineHeight: 1.1,
  }),
  statLabel: {
    fontSize: 11,
    color: "#94a3b8",
    fontWeight: 600,
    marginTop: 2,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  card: {
    background: "#fff",
    borderRadius: 18,
    boxShadow: "0 4px 28px rgba(0,0,0,0.09)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
  panelHead: (a, b) => ({
    background: `linear-gradient(120deg,${a} 0%,${b} 100%)`,
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  }),
  panelTitle: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: "#fff",
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: 0.4,
    textTransform: "uppercase",
  },
  panelBody: { padding: "22px 22px 18px" },
  inputStyle: { height: 42, borderRadius: 10, fontSize: 14 },
  sectionLabel: (color) => ({
    display: "flex",
    alignItems: "center",
    gap: 7,
    fontSize: 11,
    fontWeight: 700,
    color,
    textTransform: "uppercase",
    letterSpacing: 0.8,
    marginBottom: 12,
    marginTop: 4,
  }),
  dot: (color) => ({
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: color,
    flexShrink: 0,
  }),
  hint: {
    background: "#f8fafc",
    border: "1px dashed #cbd5e1",
    borderRadius: 10,
    padding: "10px 14px",
    fontSize: 12,
    color: "#94a3b8",
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 16,
  },
  selectedBadge: (color) => ({
    background: `${color}18`,
    border: `1px solid ${color}44`,
    borderRadius: 10,
    padding: "8px 14px",
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 16,
  }),
  badgeAvatar: (color) => ({
    width: 36,
    height: 36,
    borderRadius: 10,
    background: `linear-gradient(135deg,${color} 0%,${color}99 100%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: 18,
    flexShrink: 0,
  }),
  primaryBtn: {
    background: `linear-gradient(90deg,${from} 0%,${to} 100%)`,
    border: "none",
    borderRadius: 10,
    height: 42,
    fontWeight: 700,
    fontSize: 13,
    flex: 1,
    boxShadow: `0 4px 14px ${from}44`,
  },
});

export const rowStyles = (from) => `
  .mc-row:hover td { background: ${from}12 !important; transition: background 0.15s; }
  .mc-row-selected td { background: ${from}28 !important; }
  .mc-row-selected:hover td { background: ${from}3a !important; }
  .mc-search::placeholder { color: rgba(255,255,255,0.8); opacity: 1; }
  .mc-search::-webkit-input-placeholder { color: rgba(255,255,255,0.8); opacity: 1; }
`;
